"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCharacter = exports.setEdition = exports.setPlatform = exports.setPurchaseLanguage = exports.setLanguage = exports.getPlatform = exports.getEdition = exports.getPurchaseLang = exports.getLanguage = exports.isValidCharacter = exports.BaseDomains = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
exports.BaseDomains = {
    na: 'https://na.daemonxmachina.com/titanicscion',
    eu: 'https://eu.daemonxmachina.com/titanicscion',
    jp: 'https://jp.daemonxmachina.com/titanicscion',
    cn: 'https://asia.daemonxmachina.com/titanicscion',
};
// Helper function to validate cookies
const isValidLanguage = (lang) => {
    return [
        'en',
        'ca',
        'au',
        'nz',
        'uk',
        'fr',
        'de',
        'es',
        'it',
        'pt',
        'nl',
        'ch',
        'be',
        'pl',
        'se',
        'no',
        'dk',
        'at',
    ].includes(lang);
};
const isValidCharacter = (value) => {
    return [
        'angel',
        'arachne',
        'ash',
        'bullet',
        'forge',
        'gaze',
        'gearworm',
        'hex',
        'iris',
        'legion',
        'nerve',
        'nova',
        'raven',
        'toby',
        'void',
        'yaiba',
        'zanki',
        'blossom',
        'savvy',
        'soma',
        'chaldia',
        'osteo',
    ].includes(value);
};
exports.isValidCharacter = isValidCharacter;
const isValidEdition = (edition) => {
    return [
        'physicalLimited',
        'physicalStandard',
        'digitalStandard',
        'digitalDeluxe',
        'digitalSuper',
    ].includes(edition);
};
const isValidPlatform = (platform) => {
    return ['switch', 'ps5', 'xbox', 'steam'].includes(platform);
};
// Get Language from cookies, with validation
const getLanguage = () => {
    const lang = js_cookie_1.default.get('lang') || 'en';
    if (isValidLanguage(lang)) {
        return lang;
    }
    return 'en'; // default fallback
};
exports.getLanguage = getLanguage;
const getPurchaseLang = () => {
    const purchaseLang = js_cookie_1.default.get('purchaseLang') || js_cookie_1.default.get('lang') || 'en';
    if (isValidLanguage(purchaseLang)) {
        return purchaseLang;
    }
    return 'en';
};
exports.getPurchaseLang = getPurchaseLang;
// Get Edition from cookies, with validation
const getEdition = () => {
    const edition = js_cookie_1.default.get('edition') || undefined;
    if (isValidEdition(edition)) {
        return edition;
    }
    return 'physicalLimited'; // default fallback
};
exports.getEdition = getEdition;
// Get Platform from cookies, with validation
const getPlatform = () => {
    const platform = js_cookie_1.default.get('platform') || 'switch';
    if (isValidPlatform(platform)) {
        return platform;
    }
    return 'switch'; // default fallback
};
exports.getPlatform = getPlatform;
// Set Language cookie, ensuring a valid LanguageKey is set
const setLanguage = (lang) => {
    js_cookie_1.default.set('lang', lang);
};
exports.setLanguage = setLanguage;
const setPurchaseLanguage = (lang) => {
    js_cookie_1.default.set('purchaseLang', lang);
};
exports.setPurchaseLanguage = setPurchaseLanguage;
const setPlatform = (platform) => {
    js_cookie_1.default.set('platform', platform);
};
exports.setPlatform = setPlatform;
const setEdition = (edition) => {
    js_cookie_1.default.set('edition', edition);
};
exports.setEdition = setEdition;
const setCharacter = (character) => {
    js_cookie_1.default.set('character', character);
};
exports.setCharacter = setCharacter;
